<template>
  <svg :class="svgClass" aria-hidden="true" @click="clickHandle($event)">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
// import '@/icons/svg/test.svg';
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return `svg-icon ${this.className}`;
      } else {
        return 'svg-icon';
      }
    }
  },
  methods: {
    clickHandle(e) {
      this.$emit('click', e);
    }
  }
};
</script>

<style>
  .svg-icon {
    width: 14px;
    height: 14px;
    overflow: hidden;

    /* vertical-align: -0.15em; */
    vertical-align: middle;
    fill: currentColor;
  }
</style>
